import { useCallback, useRef, useState } from 'react';
import { ebGlobalChannel } from 'src/lib/events-bridge';
import useSubscription from 'src/lib/events-bridge/hooks/useSubscription';
import EBAPIs from 'src/lib/events-bridge/topics';
const getInitialState = () => ({
    visible: false,
    file: null,
    imageSrc: null,
});
export default function useImageCrop() {
    const [state, setState] = useState(getInitialState());
    const resolverRef = useRef(null);
    const hide = useCallback(() => {
        setState(prevState => {
            if (prevState.imageSrc) {
                URL.revokeObjectURL(prevState.imageSrc);
            }
            return getInitialState();
        });
    }, []);
    const complete = useCallback((result) => {
        const resolve = resolverRef.current;
        resolverRef.current = null;
        hide();
        resolve?.(result);
    }, [hide]);
    const show = useCallback((options) => {
        return new Promise(resolve => {
            resolverRef.current = resolve;
            setState({
                visible: true,
                file: options.file,
                imageSrc: URL.createObjectURL(options.file),
            });
        });
    }, []);
    const cancel = useCallback(() => {
        complete(null);
    }, [complete]);
    useSubscription(EBAPIs.helperViews.imageCrop.show, show);
    useSubscription(EBAPIs.helperViews.imageCrop.hide, cancel);
    const actions = {
        show,
        hide: cancel,
        complete,
    };
    return [state, actions];
}
export const imageCropHelperActions = {
    show(data) {
        return ebGlobalChannel.request(EBAPIs.helperViews.imageCrop.show, data);
    },
    hide() {
        ebGlobalChannel.publish(EBAPIs.helperViews.imageCrop.hide);
    },
};
